import { createFileRoute } from '@tanstack/react-router'

import { MarkdownDocumentEditor } from '@/components/documents/markdown-document-editor'
import { useFollowClient } from '@/lib/current-client'
import { readSearch, text } from '@/lib/search-params'

export const Route = createFileRoute('/_app/clients/$clientId_/documents/new')({
  validateSearch: (search: Record<string, unknown>) =>
    readSearch(
      {
        /** Venu de l'onglet Documents d'un projet (1.33.0) : sa référence, pour y rattacher et y revenir. */
        projet: text(),
        /** Lot 17 : « Nouvelle analyse » d'un document — son id, le parent de ce qu'on écrit. */
        parent: text(),
        /** Lot 20 : « Nouveau document » depuis un dossier — le dossier où le ranger. */
        dossier: text(),
      },
      search,
    ),
  component: NewMarkdownDocumentPage,
})

function NewMarkdownDocumentPage() {
  const { clientId } = Route.useParams()
  useFollowClient(clientId)
  const { projet, parent, dossier } = Route.useSearch()
  return (
    <MarkdownDocumentEditor
      clientId={clientId}
      projectRef={projet}
      parentId={parent}
      folderId={dossier}
    />
  )
}
